export const GET_WFH_DATA_LOADING = "GET_WFH_DATA_LOADING"
export const GET_WFH_DATA_ERROR = "GET_WFH_DATA_ERROR";
export const GET_WFH_DATA_SUCCESS = "GET_WFH_DATA_SIUCCESS";